import { forwardRef, useCallback } from 'react';
import { Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';

import { withTranslation } from '../../../locales/hoc';
import { Input } from '../Input';
import { InputProps } from '../types';
import SearchIcon from './search-input-icon.svg';
import { CloseIcon } from '../../../assets';

export const SearchInput = withTranslation(
	forwardRef<typeof Input, InputProps>(
		(props: Pick<InputProps, 'value' | 'onChangeText' | 'style'>, ref) => {
			const { t } = useTranslation();

			const reset = useCallback(() => {
				return props.onChangeText?.('');
			}, [props]);

			return (
				<Input
					ref={ref}
					inputMode="search"
					enterKeyHint="search"
					size="medium"
					accessoryLeft={<SearchIcon />}
					accessoryRight={
						props.value ? (
							<Pressable onPress={reset} hitSlop={8}>
								<CloseIcon />
							</Pressable>
						) : undefined
					}
					placeholder={t('common.search')}
					{...props}
				/>
			);
		},
	),
);
